<template>
  <nx-bform-group :label="name" v-bind="$attrs">
    <nx-bform-input
      :name="name"
      :rules="{ required, email: true }"
      :value="$attrs.value"
      @input="$listeners.input"
    />
  </nx-bform-group>
</template>

<script>
import FormGroupMixin from "../form-group.mixin";

export default {
  mixins: [FormGroupMixin],
  computed: {
    name() {
      return this.label || this.$t("email");
    }
  }
};
</script>

<i18n src="@/locales/login.locale.json" />
